// extracted by mini-css-extract-plugin
export default {"error":"EmailSignUpForm_error__NMgqi","passwordError":"EmailSignUpForm_passwordError__sC4tk"};